var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpandMore } from "@mui/icons-material";
import { AccordionDetails, AccordionSummary, Stack } from "@mui/material";
import { Accordion2 } from "../../components/accordion2";
import FaqSection from "../../components/FaqSection";
import TermosDeUso from "../../components/FaqSection/termos_de_uso";
import IntroductionSection from "../../components/IntroductionSection";
var Home = function () { return (_jsxs(Stack, __assign({ direction: "column", spacing: 0 }, { children: [_jsxs(Accordion2, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMore, {}), "aria-controls": "privacy-policy-content", id: "privacy-policy-header" }, { children: _jsx(IntroductionSection, { nome: "Pol\u00EDtica de Privacidade \u2014 Aplicativo IASPI / PLAMTA" }) })), _jsx(AccordionDetails, { children: _jsx(FaqSection, {}) })] }), _jsxs(Accordion2, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMore, {}), "aria-controls": "terms-of-use-content", id: "terms-of-use-header" }, { children: _jsx(IntroductionSection, { nome: "Termos de Uso \u2014 Aplicativo IASPI / PLAMTA" }) })), _jsx(AccordionDetails, { children: _jsx(TermosDeUso, {}) })] })] }))); };
export default Home;
